import React, {createContext, useState} from 'react'
import {useBlocker} from 'react-router-dom'
import {VmoButton, VmoModal, VmoModalActions, VmoModalContent, VmoModalHeader} from 'vmo-library'

export const UnsavedChangesContext = createContext()

const UnsavedChangesProvider = ({children}) => {
  const [warningModal, setWarningModal] = useState(false)

  const blocker = useBlocker(
    ({currentLocation, nextLocation}) => warningModal && currentLocation.pathname !== nextLocation.pathname
  )

  return (
    <UnsavedChangesContext.Provider value={{warningModal, setWarningModal}}>
      <VmoModal
        size="tiny"
        dimmer="blurring"
        open={blocker.state === 'blocked'}
        centered={false}
        onClose={() => {
          blocker.reset?.()
        }}
        closeIcon
      >
        <VmoModalHeader>Warning</VmoModalHeader>
        <VmoModalContent>
          <h5>There are some unsaved changes !</h5>
          <p className="vmo-lead">Do you still wish to leave?</p>
        </VmoModalContent>
        <VmoModalActions>
          <VmoButton
            basic
            onClick={() => {
              blocker.reset?.()
            }}
          >
            No
          </VmoButton>
          <VmoButton
            color="red"
            content="Yes"
            onClick={() => {
              blocker.proceed?.()
              setWarningModal(false)
            }}
          />
        </VmoModalActions>
      </VmoModal>

      {children}
    </UnsavedChangesContext.Provider>
  )
}

export default UnsavedChangesProvider
